import React from "react";
import BookingSummaryContainer from "../../containers/TransportationContainer/BookingSummaryContainer";

const BookingSummaryPage: React.FC = () => {
  return <BookingSummaryContainer />;
};

export default BookingSummaryPage;
